import { phoneNumber } from "core/UrlEndpoints";
import CrudService from "./CrudService";
import { fetchDataJson, fetchData } from "../FetchApi";

class PhoneNumberService extends CrudService {
  constructor() {
    super(phoneNumber);
  }

  async filterByNumber(number) {
    return fetchDataJson(`${phoneNumber}?size=${50}&page=${1}&filter[PhoneNumber]=${number}*`);
  }


}

export default new PhoneNumberService();
